// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItens_PegaItensMultiResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /config/menu_itens/pega_itens_multi.
 *
 * Returns the list of 'multi' type menu items (id + computed hierarchical
 * title) used to populate the parent-item select on the menu-items config
 * screen.
 */
import type { MenuItens_PegaItensMultiRow } from './MenuItens_PegaItensMultiRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type MenuItens_PegaItensMultiResponseDados = MenuItens_PegaItensMultiRow[];

export type MenuItens_PegaItensMultiResponse = ApiResponse<MenuItens_PegaItensMultiResponseDados>;

registerResponseContract('MenuItens_PegaItensMultiResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      menu_item_id:     { type: 'number',  required: true },
      menu_item_titulo: { type: 'string',  required: true },
    },
  },
})
